import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useDiscoveryStatus(
  projectId: number,
  workspaceId: number,
  currentDiscoveryDate: string,
  isDiscoveryOutdated: boolean,
  isCurrentPageFresh: boolean,
  params?: Record<string, unknown>
) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data, refetch } = useQuery(
    [
      "/insight-page/getDiscoveryStatus",
      { id: projectId, workspaceId, params },
    ],
    () => {
      return repository.getDiscoveryStatus(projectId, workspaceId, params);
    },
    { refetchInterval: 30_000, enabled: isDiscoveryOutdated } // polling with 30s interval
  );

  return {
    isNewDiscoveryAvailable:
      !isCurrentPageFresh &&
      data?.fresh &&
      new Date(data?.date) > new Date(currentDiscoveryDate),
    onRefetchStatus: () => refetch(),
  };
}
